import NumberFormatter from "@/services/NumberFormatter";

/**
 * Beautify a number
 * @param value the value
 * @param valueForZero the value to return if the value is 0
 * @param valueForUndefined the value to return if the value is undefined
 * @param addThousandSuffix add a thousand suffix (k, M, B, T)?
 * @param decimals the amount of decimals to show
 */
export default function beautify(
  value: number | string | undefined,
  valueForZero = "-",
  valueForUndefined = "-",
  addThousandSuffix = false,
  decimals = 0,
  floorThousandsDividedValue = true
) {
  return NumberFormatter.beautify(
    value,
    valueForZero,
    valueForUndefined,
    addThousandSuffix,
    decimals,
    floorThousandsDividedValue
  );
}
